import { AnswerValue, Question } from '../types';

export const convertSourceFieldToQuestion = (field: any): any => {
  const getQuestionType = (type?: string, responseType?: string) => {
    if (type) return type as Question['type'];
    switch (responseType) {
      case 'Radio Button':
        return 'radio';
      case 'Text':
        return 'text';
      case 'Radio + Text':
        return 'radio-text';
      default:
        return 'text';
    }
  };

  return {
    id: field.id,
    key: field.id,
    type: getQuestionType(field.type, field.response_type),
    component: field.component,
    label: field.question,
    required: false,
    options: field.options?.map((option: any) => ({
      id: option.id.toString(),
      value: option.id,
      label: option.option_text,
    })),
    hasAttachment: field.has_attachment,
    attachments: field.attachments || [],
    subQuestions: field.hasSubQuestions
      ? field.subQuestions?.map((subQ: any) =>
          convertSourceFieldToQuestion(subQ)
        )
      : undefined,
    defaultValue: field.default_value,
  };
};

export const shouldUploadSource = (question: Question): boolean | undefined => {
  const answer = question.defaultValue as AnswerValue | undefined;

  //return false if no answer
  if (!answer) return false;
  
  // Check if an option is selected
  if (answer?.selectedOptionId !== null && answer?.selectedOptionId !== undefined) {
    const selectedOption = question.options?.find(
      opt => opt.id.toString() === answer?.selectedOptionId?.toString()
    );
    return selectedOption?.has_attachment;
  } 
  
  // Check if text value is provided
  if (answer?.typedValue !== null && answer?.typedValue !== undefined) {
    return question.hasAttachment;
  }
  
  // Default: enable upload
  return true;
};
